













































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AppConsts from "@/lib/appconst";
import moment from "moment";
import _ from 'lodash'
class PageTransAuditProductItemReportRequest extends PageRequest {
  keyword: string;
  from: string;
  to: string;
  userId: number;
  workOrderTypeCode: string;
  warehouseCode: string;
}

@Component({})
export default class TransAuditProductItemReport extends AbpBase {
  //filters
  pagerequest: PageTransAuditProductItemReportRequest =
    new PageTransAuditProductItemReportRequest();
  changedPage: boolean = false;
  creationTime: Date[] = [];
  employees = [];
  workOrderTypes = [];
  get tenant() {
    return this.$store.state.session.tenant;
  }
  async getEmployees() {
    await this.$store
      .dispatch({
        type: "user/getEmployeesInWarehouse",
      })
      .then(() => {
        var re = this.$store.state.user.employees;
        re.forEach((element) => {
          element.formatName = `${element.userName} - ${element.name}`;
        });
        re.unshift({ id: -1, formatName: this.L(AppConsts.All) });
        this.$set(this.pagerequest, "userId", re[0].id);
        this.employees = re;
      });
  }
  async getWorkOrderTypes() {
    await this.$store
      .dispatch({
        type: "employeeJobDiary/getWorkOrderTypeForSelect",
        data: {
          hasAllItem: true,
        },
      })
      .then((re) => {
        this.$set(this.pagerequest, "workOrderTypeCode", re[0].code);
        this.workOrderTypes = re;
      });
  }
  async exportToExcel() {
    this.buildPageRequest();
    this.pagerequest.warehouseCode = this.tenant.tenancyName;
    await this.$store.dispatch({
      type: "inventoryReport/exportViewOpsTransAudit",
      data: this.pagerequest,
    });
  }
  get list() {
    var re = this.$store.state.inventoryReport.transAuditProductItems;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function (item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  get loading() {
    return this.$store.state.inventoryReport.loading;
  }

  pageChange(page: number) {
    this.$store.commit("inventoryReport/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("inventoryReport/setPageSize", pagesize);
    this.getpage();
  }

  onSearch() {
    this.$store.commit("inventoryReport/setCurrentPage", 1);
    this.getpage();
  }
  buildPageRequest() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
   
    if (
      this.creationTime.length > 0 &&
      !_.isNil(this.creationTime[0]) &&
      this.creationTime[0].toString() !== ""
    ) {
      this.pagerequest.from = moment(this.creationTime[0])
        .startOf("d")
        .utc()
        .format();
    } else {
      this.pagerequest.from = null;
    }
    if (
      this.creationTime.length > 1 &&
      !_.isNil(this.creationTime[1]) &&
      this.creationTime[1].toString() !== ""
    ) {
      this.pagerequest.to = moment(this.creationTime[1])
        .endOf("d")
        .utc()
        .format();
    } else {
      this.pagerequest.to = null;
    }
  }
  async getpage() {
    this.buildPageRequest();
    //filters
    await this.$store.dispatch({
      type: "inventoryReport/searchViewOpsTransAudit",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.inventoryReport.pageSize;
  }
  get totalCount() {
    return this.$store.state.inventoryReport.totalCount;
  }
  get currentPage() {
    return this.$store.state.inventoryReport.currentPage;
  }
  refreshList() {
    this.$store.commit("inventoryReport/refreshTransAuditList");
  }
  columns = [
    {
      title: Util.L("Order"),
      width: 50,
      key: "orderNo",
    },
    {
      title: Util.L("Client"),
      width: 150,
      key: "clientName",
    },
    {
      title: Util.L("SKU"),
      width: 150,
      key: "sku",
    },
    {
      title: Util.L("ProductName"),
      width: 150,
      key: "productName",
    },
    {
      title: Util.L("SerialNo"),
      width: 120,
      key: "srcSerialNo",
    },
    {
      title: Util.L("Qty"),
      width: 80,
      key: "qty",
    },
    {
      title: Util.L("WorkOrder"),
      width: 150,
      key: "workOrderTypeName",
    },
    {
      title: Util.L("RefCode"),
      width: 150,
      key: "refCode",
      slot: "refCode",
    },
    {
      title: Util.L("Employee"),
      width: 150,
      key: "userName",
    },
    {
      title: Util.L("SrcLocation"),
      width: 120,
      key: "srcLocation",
    },
    {
      title: Util.L("DstLocation"),
      width: 120,
      key: "dstLocation",
    },
    {
      title: Util.L("AssetType"),
      width: 150,
      key: "assetTypeName",
    },
    {
      title: Util.L("ConditionType"),
      width: 150,
      key: "conditionTypeName",
    },
    {
      title: Util.L("TransDate"),
      width: 170,
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.creationTime));
      },
    },
  ];

  async created() {
    this.refreshList();
    await this.getWorkOrderTypes();
    await this.getEmployees();
    var defaultDate = new Date();
    this.creationTime = [defaultDate, defaultDate];
  }
}
